import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { CollectionViewer } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';
import { PackagesHttpService } from '../_services/packages-http.service';

export class ManagePackagesDataSource implements DataSource<any> {
	private packListSubject = new BehaviorSubject<any[]>([]);
	private loadingSubject = new BehaviorSubject<boolean>(false);

	public loading$ = this.loadingSubject.asObservable();

	empty = false;

	private countSubject = new BehaviorSubject<number>(0);
	public counter$ = this.countSubject.asObservable();

	constructor(private http: PackagesHttpService) {}

	connect(collectionViewer: CollectionViewer): Observable<any[]> {
		return this.packListSubject.asObservable();
	}

	disconnect(collectionViewer: CollectionViewer): void {
		this.packListSubject.complete();
		this.loadingSubject.complete();
		this.countSubject.complete();
	}

	loadPackageList(qryParams: any) {
		this.empty = false;
		this.loadingSubject.next(true);
		this.http.getAllFiles(qryParams).pipe(
			catchError(() => of([])),
			finalize(() => {
				this.loadingSubject.next(false);
			})
		)
		.subscribe(pListD => {
			let pList = pListD.data;
			this.loadingSubject.next(false);
			console.log(pList);
			if (pList.cnt === 0) {
				this.empty = true;
			}
			this.packListSubject.next(pList.payload);
			this.countSubject.next(Math.ceil(pList.cnt));
		});
	}

	loadPackageListUI(qryParams: any) {
		this.empty = false;
		this.loadingSubject.next(true);
		this.http.getAllUIFiles(qryParams).pipe(
			catchError(() => of([])),
			finalize(() => {
				this.loadingSubject.next(false);
			})
		)
		.subscribe(pListD => {
			let pList = pListD.data;
			this.loadingSubject.next(false);
			console.log(pList);
			if (pList.cnt === 0) {
				this.empty = true;
			}
			this.packListSubject.next(pList.payload);
			this.countSubject.next(Math.ceil(pList.cnt));
		});
	}

	loadBundleSpec(qryParams: any) {
		this.empty = false;
		this.loadingSubject.next(true);
		this.http.getBundleSpec(qryParams).pipe(
			catchError(() => of([])),
			finalize(() => {
				this.loadingSubject.next(false);
			})
		)
		.subscribe(bundleD => {
			let bundle = bundleD.data;
			this.loadingSubject.next(false);
			console.log("bundle package", bundle);
			if (bundle.cnt === 0) {
				this.empty = true;
			}
			this.packListSubject.next(bundle.payload);
			this.countSubject.next(Math.ceil(bundle.cnt));
		});
	}
}
